// Sdílené horní meze délky pro volné textové vstupy (FR01 PART1). Konkrétní hodnota se přiřazuje
// podle charakteru pole - krátký text (adresa apod.), zdůvodnění/důvod, nebo delší poznámka.
export const MAX_SHORT_TEXT_LENGTH = 255;
export const MAX_REASON_LENGTH = 500;
export const MAX_NOTE_LENGTH = 2000;
// Horní meze délky pro jednořádková identifikační pole (FR02 PART1) - dosud bez jakéhokoli limitu.
export const MAX_PERSON_NAME_LENGTH = 100;
export const MAX_TITLE_LENGTH = 200;
export const MAX_PHONE_LENGTH = 30;
export const MAX_TIMEZONE_LENGTH = 64;
// Sjednocuje dřívější lokální pattern `trainerSkillsSchema` (trainer.ts) i pro `targetTags`/`tags`
// (FR02 PART1) - hodnoty beze změny (40 znaků na položku, max 20 položek v poli).
export const MAX_TAG_LENGTH = 40;
export const MAX_TAGS_COUNT = 20;
// Bezpečná rezerva nad skutečný formát MFA/step-up kódu (FR02 PART1, Otevřená rozhodnutí) - aktuální
// recovery kód má tvar XXXX-XXXX-XXXX (14 znaků), starší osmiznakové kódy zůstávají ověřitelné
// (apps/functions/src/lib/mfa-totp.ts) - 32 znaků má rezervu nad oba formáty i TOTP 6místný kód.
export const MAX_MFA_CODE_LENGTH = 32;
// RFC 5321 limit cesty (forward-path) pro e-mailovou adresu (FR02 20261002_Odlozene_P3/001_Database,
// OD-095). Jediný zdroj hodnoty pro Zod schémata e-mailu, frontendovou validaci, backendovou syntaktickou
// kontrolu odesílání (apps/functions/src/lib/email/email-address.ts) i DB CHECK `*_email_max_length`.
export const MAX_EMAIL_LENGTH = 254;
export const EMAIL_TOO_LONG_MESSAGE = 'E-mailová adresa je příliš dlouhá.';
// Technická horní mez celočíselných vstupů mapovaných na sloupec `integer` (int4) (FR01
// 20261002_Odlozene_P3/002_Api, FR-04, OR-02 A). Hodnota nad ní by prošla Zodem a Postgres by ji
// odmítl jako `numeric_value_out_of_range` (22003). Doménové meze se tím nezavádějí. Stejná mez
// platí pro `page` ve stránkování, aby `OFFSET` nepřetekl `bigint`.
export const MAX_INT4 = 2_147_483_647;
export const INT4_TOO_LARGE_MESSAGE = 'Hodnota je příliš vysoká.';
